//
// ControllerOperations.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";

var ControllerOperations = createModule("gtl::ControllerOperations", [], EventDispatcher, [
    {
        CONTROLLER_LISTENER_ADDED: 30005,
        CONTROLLER_EVENT_TYPE: 30004,
    },
    ,
    ,
    ,
    ,
    ,
    ,
]);
export default ControllerOperations;
